import React from "react";
import { loadFields } from "../formFields/asnTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function LoadTab({ formData, onChange, formSubmissionAttempted, readOnly }) {
  return (
    <GenericFormTab
      fields={loadFields}
      formData={formData}
      onChange={onChange}
      formSubmissionAttempted={formSubmissionAttempted}
      readOnly={readOnly} // ✅ Pass through readOnly prop
    />
  );
}
